module.exports = __webpack_public_path__ + "assets/img/outlook.4cd0b40d.svg";